import React from 'react';
import AuthService from './authService';
import serviceHelper from '../Helpers/serviceHelper';

export default class ReportService extends React.Component {
  static GetReport(reportName, reportParams, page, format, refresh) {
    const authService = AuthService.getInstance();
    reportParams = serviceHelper.ConvertAllPropertyToStringForReport(reportParams);
    const url = `/api/Report/GetReportByName?reportName=${encodeURIComponent(reportName)}&reportParams=${JSON.stringify(
      reportParams
    )}&page=${page}&format=${format}&clearCache=${refresh}`;
    return authService.CallBackendFunction(url);
  }

  static StartReport(reportName, reportParams, page, format) {
    const authService = AuthService.getInstance();
    reportParams = serviceHelper.ConvertAllPropertyToStringForReport(reportParams);
    const url = `/api/Report/StartReportByName?reportName=${encodeURIComponent(reportName)}&reportParams=${JSON.stringify(
      reportParams
    )}&page=${page}&format=${format}`;
    return authService.CallBackendFunctionPost(url, null);
  }

  static GetReportStatus(jobId) {
    const authService = AuthService.getInstance();
    const url = `/api/Report/GetReportStatus/${jobId}`;
    return authService.CallBackendFunction(url);
  }

  static GetReportAsync(reportName, reportParams, page, format, onProgress) {
    return this.StartReport(reportName, reportParams, page, format).then((startResult) => {
      const jobId = startResult.jobId;
      return new Promise((resolve, reject) => {
        const poll = () => {
          ReportService.GetReportStatus(jobId)
            .then((statusResult) => {
              if (statusResult.status === 'Processing') {
                if (onProgress) onProgress();
                setTimeout(poll, 3000);
              } else if (statusResult.status === 'Completed') {
                resolve(statusResult.result);
              } else {
                reject(new Error(statusResult.error || 'Report generation failed.'));
              }
            })
            .catch(reject);
        };
        poll();
      });
    });
  }

  static GetReportParameters(reportParams, reportName) {
    const authService = AuthService.getInstance();
    reportParams = serviceHelper.ConvertAllPropertyToStringForReport(reportParams);
    const url = `/api/Report/GetParamsByReportName?reportParams=${JSON.stringify(
      reportParams
    )}&reportName=${encodeURIComponent(reportName)}&clearCache=false`;
    return authService.CallBackendFunction(url);
  }
}
